import _ from 'lodash';

export const getFieldInfo = (schema, name) => {
  const schema_key = name.replace(/_\d{1,2}_/, '_x_');

  if (!schema[schema_key]) return {};

  return {...schema[schema_key], name};
};

export const getFieldInitialValue = (key, data = {}) => {
  if (_.isEmpty(data)) return {initialValues: null, key};
  if (!data[key]) return {initialValues: null, key};

  return {initialValues: data[key], name: key};
};

export const getFieldError = (key, error = {}) => {
  if (_.isString(error)) return {error, name: key};

  if (!_.isObject(error)) return {error: {}, name: key};

  if (error[key]) {
    return {error: error, name: key};
  }

  return {name: key, error: {}};
};
export const getSchemaInitialValues = schema => {
  const initialValues = {};
  _.keys(schema).forEach(key => {
    initialValues[key] = schema[key].value ? schema[key].value : '';
  });
  return initialValues;
};

const getFullFormField = (schema, key, data = {}, error = {}) => {
  const {data: _data, error: _error, key: _key} = _.isObject(key) ? key : {key, data, error};

  return {
    ...getFieldInfo(schema, _key),
    ...getFieldInitialValue(_key, _data),
    ...getFieldError(_key, _error),
    'autocomplete': 'nope',
  };
};

export const populateFields = (data = {}) => {
  let out = {};
  _.forEach(data, (v, k) => {
    if (data[k] !== null) {
      out = {...out, [k]: v};
    }
  });
  return out;
};

export default getFullFormField;